import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { JvBrokerServices } from '../../services/JvBrokerServices';
import Swal from 'sweetalert2';
import * as BullCache from "../../util/BullCache";

function Jvbroker() {

    const [broker, setBroker] = useState([]);
    const [selectedDebitClient, setSelectedDebitClient] = useState('');
    const [selectedCreditClient, setSelectedCreditClient] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
    const [selectedPaymentType, setSelectedPaymentType] = useState('CASH');
    const filteredClientsForCredit = broker.filter(b => b.adminId !== selectedDebitClient);
    const [selectedBalance1, setSelectedBalance1] = useState(0);  
    const [selectedBalance2, setSelectedBalance2] = useState(0); 
    const [amount, setAmount] = useState('');
    const [remarks, setRemarks] = useState('');

    var user = BullCache.getFromCache("user");
    useEffect(() => {
        JvBrokerServices.getBrokers({ 'adminId': user.adminId }).then(res => {

            if (res.code === 1) {
                if (res.data.brokerList.length > 0) {

                    setBroker(res.data.brokerList);
                }
            }
        });
    }, [user.adminId]);
    
    const handleDebitClientChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedDebitClient(selectedOption.value);
            const clientData = broker.find(c => c.adminId === selectedOption.value);
            if (clientData) {
                setSelectedBalance1(clientData.balance);
            }
        } else {
            setSelectedDebitClient(null);  
            setSelectedBalance1(0);  
        }
    };
    const handleCreditClientChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedCreditClient(selectedOption.value);
            const clientData = broker.find(c => c.adminId === selectedOption.value);
            if (clientData) {
                setSelectedBalance2(clientData.balance);
            }
        } else {
            setSelectedCreditClient(null);  
            setSelectedBalance2(0);  
        }
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    const handlePaymentTypeChange = (e) => {
        setSelectedPaymentType(e.target.value);
    };

    const handleAmountChange = (e) => {
        setAmount(e.target.value);
    };

    const handleRemarksChange = (e) => {
        setRemarks(e.target.value);
    };

    const jvClear = () => {
        setSelectedDebitClient('');
        setSelectedCreditClient('');
        setSelectedDate(new Date().toISOString().split('T')[0]);  
        setAmount('');
        setRemarks('');
        setSelectedPaymentType('CASH');
    };

    const jvBrokerEntry = () => {
         if (!selectedDebitClient || !selectedCreditClient || !amount || !selectedDate || parseFloat(amount) <= 0) {
                    Swal.fire({
                        icon: "warning",
                        text: "Please fill all required fields ",
                    });
                    return; 
                }
        const payment = {
            from: selectedDebitClient,
            to: selectedCreditClient,
            paymentType: selectedPaymentType,
            jvType: "BROKER",
            amount: amount,
            createdDate: selectedDate,
            remark: remarks
        };

        JvBrokerServices.getJvBrokerEntry(payment).then(resp => {
            if (resp.code === 1) {
                Swal.fire({
                    icon: "success",
                    text: "Success !",
                });
                setSelectedDebitClient('');
                setSelectedCreditClient('');
                setSelectedDate(new Date().toISOString().split('T')[0]);  
                setAmount('');
                setRemarks('');
                setSelectedPaymentType('CASH');
            } else {
                Swal.fire({
                    icon: "error",
                    text: "Something Went to Wrong !",
                });
            }
        });
    };

    return (

        <Card className=' mt-2 '>
            <Card.Body>
                <Row>
                    <Col sm={2}>
                        <b className=' fss-08'>DABIT ACCONUT  <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>

                    <Col sm={4}>
                        <Select
                            className="text-black"
                            options={broker.map(b => ({
                                label: `${b.firstName} (${b.userName})`,
                                value: b.adminId
                            }))}
                            value={selectedDebitClient ? {
                                value: selectedDebitClient,
                                label: broker.find(b => b.adminId === selectedDebitClient)
                                    ? `${broker.find(b => b.adminId === selectedDebitClient).firstName} (${broker.find(b => b.adminId === selectedDebitClient).userName})`
                                    : ''
                            } : null}
                            onChange={handleDebitClientChange}
                            placeholder="Select Broker"
                            isClearable
                        />

                    </Col>

                    {selectedDebitClient && (
                        <Col className='mt-2'>{selectedBalance1}</Col>
                    )}

                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className=' fss-08' style={{ fontSize: 12 }}>CREDIT ACCONUT  <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>

                    <Col sm={4}>
                        <Select
                            className="text-black"
                            options={filteredClientsForCredit.map(b => ({
                                label: `${b.firstName} (${b.userName})`,
                                value: b.adminId
                            }))}
                            value={selectedCreditClient ? {
                                value: selectedCreditClient,
                                label: broker.find(b => b.adminId === selectedCreditClient)
                                    ? `${broker.find(b => b.adminId === selectedCreditClient).firstName} (${broker.find(b => b.adminId === selectedCreditClient).userName})`
                                    : ''
                            } : null}
                            onChange={handleCreditClientChange}
                            placeholder="Select Broker"
                            isClearable
                        />


                    </Col>

                    {selectedCreditClient && (
                        <Col className='mt-2'>{selectedBalance2}</Col>
                    )}
                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className=' fss-08'>DATE  <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>

                    <Col sm={4}>
                        <input className="form-control bg-light text-black" type="date" size="lg"
                            value={selectedDate} 
                            onChange={handleDateChange} defaultValue={new Date().toISOString().split('T')[0]} />

                    </Col>
                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className='  fss-08'> PAYMENT TYPE</b>
                    </Col>

                    <Col sm={4} >

                        {['radio'].map((type) => (
                            <div key={`inline-${type}`} className="mb-3 border form-control">
                                <Form.Check
                                    inline
                                    label="CASH"
                                    className='h6 fss-08'
                                    name="group2"
                                    type={type}
                                    id={`inline-${type}-2`}
                                    checked={selectedPaymentType === "CASH"}
                                    onChange={handlePaymentTypeChange}
                                    value="CASH"
                                />
                                <Form.Check
                                    inline
                                    label="ONLINE"
                                    className='h6 fss-08'
                                    name="group2"
                                    type={type}
                                    id={`inline-${type}-2`}
                                    checked={selectedPaymentType === "ONLINE"}
                                    onChange={handlePaymentTypeChange}
                                    value="ONLINE"
                                />

                            </div>
                        ))}
                    </Col>
                </Row>

                <Row>
                    <Col sm={2}>
                        <b className=' fss-08' >AMOUNT  <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>

                    <Col sm={4}>
                        <input type='number' className='bg-light text-black form-control'
                            value={amount} 
                            onChange={handleAmountChange} />
                    </Col>

                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className=' fss-08'>REMARKS</b>
                    </Col>

                    <Col sm={4}>
                        <input type="text" className="form-control bg-light text-black" id="exampleFormControlInput1"
                            value={remarks}
                            onChange={handleRemarksChange} />
                    </Col>
                </Row>

                <Row className='mt-2'>
                    <Col sm={2}>

                    </Col>

                    <Col sm={4}>

                        <Button className='w-25' variant="success" onClick={jvBrokerEntry}>Save</Button>{' '}
                        <Button className='w-25' variant="danger" onClick={jvClear} >Clear</Button>

                    </Col>
                </Row>

            </Card.Body>
        </Card>

    );

}
export default Jvbroker;